import { faBadgePercent } from '@fortawesome/pro-light-svg-icons/faBadgePercent';
import { ToolbarButton, ToolbarItem } from 'components/UI';
import { FunctionComponent } from 'react';
import Header from './UI/Header';

export interface CheckoutHeaderProps {
    title: string;
    loading?: boolean;
    onClose?: () => void;
    onBack?: () => void;
    onAddDiscount?: () => void;
    className?: string;
}

export const CheckoutHeader: FunctionComponent<CheckoutHeaderProps> = props => {
    return (
        <Header {...props}>
            {props.onAddDiscount && (
                <ToolbarButton>
                    <ToolbarItem
                        icon={faBadgePercent}
                        text="Add Discount"
                        onClick={props.onAddDiscount}
                    />
                </ToolbarButton>
            )}
        </Header>
    );
};

export default CheckoutHeader;
